/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  query PlatformReadQuery {
    PlatformRead {
      id
      displayName
      logo
      copyright
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index
